import { useNavigate } from '@tanstack/react-router'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { CompanyDetailsForm } from '~/features/company-details/company-details-form'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { Card, CardContent } from '~/shared/ui/card'
import { Skeleton } from '~/shared/ui/skeleton'
import { SetupFrame } from './setup-frame'

/** Step two of the first setup: the company details, which can also wait until later. */
export function CompanySetupPage() {
  const navigate = useNavigate()
  const { data: business } = useCurrentBusiness()
  const toDashboard = () => navigate({ to: '/dashboard' })

  return (
    <SetupFrame onboardingStep={2}>
      <div className="mx-auto flex w-full max-w-xl flex-col gap-8 pt-6 sm:pt-14">
        <div className="flex flex-col gap-3 text-center">
          <h1 className="text-balance font-semibold text-3xl text-foreground leading-[1.1] tracking-[-0.03em] sm:text-4xl">
            {m.companyDetailsTitle()}
          </h1>
          <p className="text-balance text-base text-muted-foreground sm:text-lg">
            {m.companyDetailsSubtitle()}
          </p>
        </div>
        {business ? (
          <Card>
            <CardContent className="pt-6">
              <CompanyDetailsForm
                key={business.id}
                business={business}
                onSaved={toDashboard}
                secondaryAction={
                  <Button type="button" variant="ghost" onClick={toDashboard}>
                    {m.companyDetailsLater()}
                  </Button>
                }
              />
            </CardContent>
          </Card>
        ) : (
          <Skeleton className="h-80 w-full rounded-xl" />
        )}
      </div>
    </SetupFrame>
  )
}
